/* eslint-disable no-mixed-spaces-and-tabs */
import axios, { AxiosInstance, AxiosResponse } from "axios";
import authService from "./auth.service";

export class APIService {
  public httpClient: AxiosInstance;
  public constructor(baseURL: string) {
    this.httpClient = axios.create({
      baseURL,
    });
  }

  public async Get(urlPath: string): Promise<AxiosResponse> {
    await this.getAccessToken();
    const resp = await this.httpClient.get(urlPath);
    if (resp.status != 200)
      throw Error(
        `${resp.config.url} returned status code ${resp.status} with the following message: ${resp.statusText}`
      );

    return resp;
  }

  public async post<P>(urlPath: string, data: P): Promise<AxiosResponse> {
    await this.getAccessToken();

    const resp = await this.httpClient.post(urlPath, data);
    if (resp.status != 200)
      throw Error(
        `${resp.config.url} returned status code ${resp.status} with the following message: ${resp.statusText}`
      );

    return resp;
  }

  public async delete(urlPath: string): Promise<AxiosResponse> {
    await this.getAccessToken();

    const resp = await this.httpClient.delete(urlPath);
    if (resp.status != 200)
      throw Error(
        `${resp.config.url} returned status code ${resp.status} with the following message: ${resp.statusText}`
      );

    return resp;
  }
  private async getAccessToken(): Promise<void> {
    this.httpClient.interceptors.request.use(
      async (config) => {
        const authToken = await authService.getAccessToken();
        config.headers.Authorization = `Bearer ${authToken}`;
        return config;
      },
      (err) => {
        console.log("Call failed with error: ", err);
      }
    );
  }
}
